import Alert from '../common/Alert.js';
import RowActionsMenu from '../common/RowActionsMenu.js';
import { isShipmentUnloaded, itclActionBlockedMessage, itclRowActions, shipmentOnMlSheet } from './itclShipmentActions.js';

const OgclShipmentActionsMenu = ({
  menuKey,
  openMenuId,
  setOpenMenuId,
  shipment,
  role,
  canManage,
  acting,
  onView,
  onUnload,
  onRevert,
  onRemove,
  onNote,
}) => {
  const unloaded = isShipmentUnloaded(shipment);
  const onMlSheet = shipmentOnMlSheet(shipment);
  const actions = itclRowActions({
    role,
    unloaded,
    onMlSheet,
    canManage,
  });

  const run = (allowed, action, fn) => {
    if (acting) return;
    if (!allowed) {
      Alert.error(itclActionBlockedMessage(actions, action));
      return;
    }
    fn?.(shipment);
  };

  const extraItems = [];
  if (actions.showUnload) {
    extraItems.push({
      key: 'unload',
      label: 'Unload',
      variant: 'success',
      onClick: () => run(actions.canUnload, 'unload', onUnload),
    });
  }
  if (actions.showNote) {
    extraItems.push({
      key: 'note',
      label: 'Note',
      variant: 'default',
      onClick: () => run(actions.canNote, 'note', onNote),
    });
  }
  if (actions.showRevert) {
    extraItems.push({
      key: 'revert',
      label: 'Revert',
      variant: 'primary',
      onClick: () => run(actions.canRevert, 'revert', onRevert),
    });
  }
  if (actions.showRemove) {
    extraItems.push({
      key: 'remove',
      label: 'Remove from ITCL request',
      variant: 'danger',
      onClick: () => run(actions.canRemove, 'remove', onRemove),
    });
  }

  return (
    <RowActionsMenu
      className="relative menu-container inline-flex"
      isOpen={openMenuId === menuKey}
      onToggle={() => setOpenMenuId(openMenuId === menuKey ? null : menuKey)}
      onClose={() => setOpenMenuId(null)}
      onView={onView}
      viewLabel="View"
      extraItems={extraItems}
    />
  );
};

export default OgclShipmentActionsMenu;
